export default "__VITE_ASSET__D$BFX1q8__"